import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { SignUpSkeleton } from "../../../../../atoms/effects/skeletons/sign-up/SignUpSkeleton";
import { ProgressBar } from './components/ProgressBar';
import { Benefits } from './components/Benefits';
import { SignUpForm } from './components/CustomForm';

export const Content = ({ signUpModel }) => {
  const [activeStep, setActiveStep] = useState(0);
  const [osSchema, setOsSchema] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    const {formId, formLocale, formDefinitionEndpointPath} = signUpModel;
    const fetchData = async () => {
      try {
        if (formId && formLocale && formDefinitionEndpointPath) {
          const response = await fetch(`${formDefinitionEndpointPath}?formId=${formId}&locale=${formLocale}`);
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          const formSchema = await response.json();
          setOsSchema(formSchema);
          setIsLoading(false);
        }
      } catch (error) {
        console.error('Failed to fetch form schema:', error);
        setIsError(true);
        setIsLoading(false);
      }
    }
    fetchData();
  }, [signUpModel]);

  const content =
      isLoading ? <SignUpSkeleton /> :
      isError ? <div className={"sign-up__form sign-up__form--error"}>There has been a problem</div> :
        <>
          <ProgressBar steps={osSchema.form.map(schema => schema.name)} activeStep={activeStep}/>
          <SignUpForm activeStep={activeStep} setActiveStep={setActiveStep} form={osSchema.form}/>
        </>;

  return (
    <main className={"sign-up__content"}>
      {content}
      <Benefits signUpModel={signUpModel}/>
    </main>
  )
}

Content.PropTypes = {
  signUpModel: PropTypes.object.isRequired
}
